import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
 LAYOUT_TYPES,
 LAYOUT_MODE_TYPES,
 LAYOUT_SIDEBAR_TYPES,
 LAYOUT_WIDTH_TYPES,
 LAYOUT_POSITION_TYPES,
 LAYOUT_TOPBAR_THEME_TYPES,
 LEFT_SIDEBAR_SIZE_TYPES,
 LEFT_SIDEBAR_VIEW_TYPES,
 LEFT_SIDEBAR_IMAGE_TYPES,
 PRELOADER_TYPES,
 SIDEBAR_VISIBILITY_TYPES
} from '../../Components/constants/layout'

export interface LayoutState {
 layoutType:
 | LAYOUT_TYPES.HORIZONTAL
 | LAYOUT_TYPES.VERTICAL
 | LAYOUT_TYPES.TWOCOLUMN
 | LAYOUT_TYPES.SEMIBOX
 layoutModeType: LAYOUT_MODE_TYPES.LIGHTMODE | LAYOUT_MODE_TYPES.DARKMODE
 leftSidebarType:
 | LAYOUT_SIDEBAR_TYPES.LIGHT
 | LAYOUT_SIDEBAR_TYPES.DARK
 | LAYOUT_SIDEBAR_TYPES.GRADIENT
 | LAYOUT_SIDEBAR_TYPES.GRADIENT_2
 | LAYOUT_SIDEBAR_TYPES.GRADIENT_3
 | LAYOUT_SIDEBAR_TYPES.GRADIENT_4
 layoutWidthType: LAYOUT_WIDTH_TYPES.FLUID | LAYOUT_WIDTH_TYPES.BOXED
 layoutPositionType: LAYOUT_POSITION_TYPES.FIXED | LAYOUT_POSITION_TYPES.SCROLLABLE
 topbarThemeType: LAYOUT_TOPBAR_THEME_TYPES.LIGHT | LAYOUT_TOPBAR_THEME_TYPES.DARK
 leftSidebarSizeType:
 | LEFT_SIDEBAR_SIZE_TYPES.DEFAULT
 | LEFT_SIDEBAR_SIZE_TYPES.COMPACT
 | LEFT_SIDEBAR_SIZE_TYPES.SMALLICON
 | LEFT_SIDEBAR_SIZE_TYPES.SMALLHOVER
 leftSidebarViewType: LEFT_SIDEBAR_VIEW_TYPES.DEFAULT | LEFT_SIDEBAR_VIEW_TYPES.DETACHED
 leftSidebarImageType:
 | LEFT_SIDEBAR_IMAGE_TYPES.NONE
 | LEFT_SIDEBAR_IMAGE_TYPES.IMG1
 | LEFT_SIDEBAR_IMAGE_TYPES.IMG2
 | LEFT_SIDEBAR_IMAGE_TYPES.IMG3
 | LEFT_SIDEBAR_IMAGE_TYPES.IMG4
 preloader: PRELOADER_TYPES.ENABLE | PRELOADER_TYPES.DISABLE
 sidebarVisibilitytype: SIDEBAR_VISIBILITY_TYPES.SHOW | SIDEBAR_VISIBILITY_TYPES.HIDDEN
}

export const initialState: LayoutState = {
 layoutType: LAYOUT_TYPES.VERTICAL,
 leftSidebarType: LAYOUT_SIDEBAR_TYPES.DARK,
 layoutModeType: LAYOUT_MODE_TYPES.LIGHTMODE,
 layoutWidthType: LAYOUT_WIDTH_TYPES.FLUID,
 layoutPositionType: LAYOUT_POSITION_TYPES.FIXED,
 topbarThemeType: LAYOUT_TOPBAR_THEME_TYPES.LIGHT,
 leftSidebarSizeType: LEFT_SIDEBAR_SIZE_TYPES.DEFAULT,
 leftSidebarViewType: LEFT_SIDEBAR_VIEW_TYPES.DEFAULT,
 leftSidebarImageType: LEFT_SIDEBAR_IMAGE_TYPES.NONE,
 preloader: PRELOADER_TYPES.DISABLE,
 sidebarVisibilitytype: SIDEBAR_VISIBILITY_TYPES.SHOW
}

const LayoutSlice = createSlice({
 name: 'LayoutSlice',
 initialState,
 reducers: {
 changeLayoutAction(state, action: PayloadAction<LayoutState['layoutType']>) {
 state.layoutType = action.payload
 },
 changeLayoutModeAction(state, action: PayloadAction<LayoutState['layoutModeType']>) {
 state.layoutModeType = action.payload
 },
 changeSidebarThemeAction(state, action: PayloadAction<LayoutState['leftSidebarType']>) {
 state.leftSidebarType = action.payload
 },
 changeLayoutWidthAction(state, action: PayloadAction<LayoutState['layoutWidthType']>) {
 state.layoutWidthType = action.payload
 },
 changeLayoutPositionAction(state, action: PayloadAction<LayoutState['layoutPositionType']>) {
 state.layoutPositionType = action.payload
 },
 changeTopbarThemeAction(state, action: PayloadAction<LayoutState['topbarThemeType']>) {
 state.topbarThemeType = action.payload
 },
 changeLeftsidebarSizeTypeAction(state, action: PayloadAction<LayoutState['leftSidebarSizeType']>) {
 state.leftSidebarSizeType = action.payload
 },
 changeLeftsidebarViewTypeAction(state, action: PayloadAction<LayoutState['leftSidebarViewType']>) {
 state.leftSidebarViewType = action.payload
 },
 changeSidebarImageTypeAction(state, action: PayloadAction<LayoutState['leftSidebarImageType']>) {
 state.leftSidebarImageType = action.payload
 },
 changePreLoaderAction(state, action: PayloadAction<LayoutState['preloader']>) {
 state.preloader = action.payload
 },
 changeSidebarVisibilityAction(state, action: PayloadAction<LayoutState['sidebarVisibilitytype']>) {
 state.sidebarVisibilitytype = action.payload
 }
 }
})

export const {
 changeLayoutAction,
 changeLayoutModeAction,
 changeSidebarThemeAction,
 changeLayoutWidthAction,
 changeLayoutPositionAction,
 changeTopbarThemeAction,
 changeLeftsidebarSizeTypeAction,
 changeLeftsidebarViewTypeAction,
 changeSidebarImageTypeAction,
 changePreLoaderAction,
 changeSidebarVisibilityAction
} = LayoutSlice.actions

export default LayoutSlice.reducer
